/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages } from '@nebula/izzy/intl';
import Checkbox from '@react/react-spectrum/Checkbox';

import Copy from '@nebula/luna/dist/core/copy';

import introImage from '../../../images/S_IlluIntroPipe_400x200.gif';
import quickConnectImage from '../../../images/S_IlluIntroPipe_Shake_200x200.gif';
import styles from './styles/intro.content.styl';

const MSG = defineMessages({
  intro: {
    id: 'gemini.session.create.intro',
    defaultMessage: 'Welcome to Project Griffon! To create a session, choose an option and complete the steps below.'
  },
  modeQuickConnect: {
    id: 'gemini.session.create.mode.quickConnect',
    defaultMessage: 'Quick connect (first session only; Assurance version 1.1+ required)'
  },
  modeLink: {
    id: 'gemini.session.create.mode.link',
    defaultMessage: 'Deep link'
  },
  stepOne: {
    id: 'gemini.session.create.step.one',
    defaultMessage: '1. Provide the session details'
  },
  stepTwo: {
    id: 'gemini.session.create.step.two',
    defaultMessage: '2. Open the link in an app.'
  },
  stepThree: {
    id: 'gemini.session.create.step.three',
    defaultMessage: '3. Enter the PIN and connect.'
  },
  stepOneQuickConnect: {
    id: 'gemini.session.quickConnect.step.one',
    defaultMessage: '1. Open the app and shake the device.'
  },
  stepTwoQuickConnect: {
    id: 'gemini.session.quickConnect.step.two',
    defaultMessage: '2. Select the device and click connect.'
  }
});

const SessionCreateIntroContent = ({
  izzy,
  quickConnect,
  onQuickConnect,
  showQuickConnectOption
}) => (
  <div
    data-omega-element="create session intro"
    data-omega-widget="create session intro"
    data-omega-widget-type="modal"
  >
    <Copy className={styles.intro}>
      {izzy(MSG.intro)}
    </Copy>
    {showQuickConnectOption && (
    <Checkbox
      checked={quickConnect}
      data-test-id="quickConnectCheckbox"
      label={izzy(MSG.modeQuickConnect)}
      onChange={onQuickConnect}
    />
    )}
    {quickConnect ? (
      <React.Fragment>
        <img alt="" className={styles.image} src={quickConnectImage} />
        <div>{izzy(MSG.stepOneQuickConnect)}</div>
        <div>{izzy(MSG.stepTwoQuickConnect)}</div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <img alt="" className={styles.image} src={introImage} />
        <div>{izzy(MSG.stepOne)}</div>
        <div>{izzy(MSG.stepTwo)}</div>
        <div>{izzy(MSG.stepThree)}</div>
      </React.Fragment>
    )}
  </div>
);

SessionCreateIntroContent.displayName = 'SessionCreateIntroContent';
export default SessionCreateIntroContent;
